import _app from '@core_modules/theme/pages/_app';

/*
 * Import css
 */
import '@core/styles/globals.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
// import 'animate.css';
import 'open-iconic/font/css/open-iconic-bootstrap.css';

export default _app;
